'use strict';

function CompanyGroupService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId', {type: 'HIDDEN'}, {
    'update': { method: 'PUT' },
    'getMyPortals': {
    	method: 'GET',
    	url: config.apiBase + '/companies/:companyId/groups?userId=:userId',
    	isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyGroupService', ['$resource', 'config', CompanyGroupService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/groups/CompanyGroupService.js
// module id = 7
// module chunks = 0